import { render } from "./LotArea.vue?vue&type=template&id=88503058&scoped=true"
import script from "./LotArea.vue?vue&type=script&lang=js"
export * from "./LotArea.vue?vue&type=script&lang=js"

import "./LotArea.vue?vue&type=style&index=0&id=88503058&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88503058"]])

export default __exports__